import React, {memo} from 'react';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';

// Important: can we guarantee source of html? This isn't the safest approach if the html isn't internally generated or from a trusted source: Thoughts?
export const StoryTextParser = memo(({storyText}) => storyText && <Container  dangerouslySetInnerHTML={{__html: storyText}}></ Container>);

const Container = styled.div`
    display: block;
    overflow-wrap: break-word;
    white-space: initial;
    display: -webkit-box;
    width: 100%;
    height: 100%;
    font-size: 16px;
    position: relative;
    line-height: 1.5;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @media ${smallMediaQuery} {
        line-height: 24px;
        text-overflow: ellipsis;
    }
    @media ${mediumMediaQuery} {
        -webkit-line-clamp: 4;
    }
    @media ${largeMediaQuery} {
        -webkit-line-clamp: 6;
    }
`;
